/** @jsx jsx */
// @ts-check
import { gql } from '@apollo/client';
import { Label } from '@bottlebooks/gatsby-design-system';
import { Link } from '@bottlebooks/gatsby-theme-base/src';
import { graphql } from 'gatsby';
import React from 'react';
import { jsx } from 'theme-ui';

/**
 *
 * @param {object} props
 * @param {object} props.stand
 * @param {object} [props.exhibitor]
 * @param {string} [props.to]
 * @param {string} [props.href]
 * @param {() => void} [props.onClick]
 */
export default function ProductStand({
  stand,
  exhibitor,
  to,
  href,
  onClick,
  ...rest
}) {
  const standNameText = [stand?.roomName, stand?.floorName, stand?.name]
    .filter(Boolean)
    .join(' / ');

  return (
    <Label {...rest}>
      <Link to={to} onClick={onClick} href={href}>
        {[standNameText, exhibitor?.name].filter(Boolean).join(' — ') || (
          <React.Fragment>&nbsp;</React.Fragment>
        )}
      </Link>
    </Label>
  );
}

export const fragment = graphql`
  fragment bb_ProductStand on Bottlebooks_SingleRegistration {
    profile {
      name
    }
    stand {
      name
      roomName
      floorName
    }
  }
  fragment ProductStand on Product {
    exhibitor {
      name
    }
    stand {
      name: title
    }
  }
`;

export const ProductStandFragment = gql`
  fragment ProductStand on Product {
    ... on ExtendedProduct {
      exhibitor {
        name
      }
      stand {
        name
      }
    }
  }
`;
